module.exports = {
    methods: {
      hasAnyPermission: function (permissions) {

        var allPermissions = this.$page.props.auth.can;
        var hasPermission = false;
        permissions.forEach(function(item){
          if(allPermissions[item]) hasPermission = true;
        });
        return hasPermission;
      },
    },
}
